import Vue from 'vue';
import getArticleVersion from '@/store/actions/utils/getArticleVersion';
import setMediaObjectsSources from '@/tools/setMediaObjectsSources';

function getBlockModal({ id, content }) {
	if (!content?.elements) return;
	const element = content.elements.find((element) => element.uid === id);
	if (element) return element;

	const child = content.elements.reduce((acc, element) => {
		return getBlockModal({ id, content: element });
	}, {});
	return child || [];
}

export default {
	state: {
		id: '',
		modifier: '',
		content: [],
	},
	mutations: {
		SET_MODAL_ID(state, id) {
			state.id = id;
		},
		SET_MODAL_CONTENT(state, content) {
			state.content = content;
		},
		SET_MODAL_MODIFIER(state, modifier) {
			state.modifier = modifier;
		},
	},
	actions: {
		hideModal({ commit }) {
			commit('SET_MODAL_ID', '');
		},
		async setupModal({ commit, dispatch }, modalId) {
			commit('SET_MODAL_CONTENT', []);
			commit('SET_MODAL_MODIFIER', '');
			commit('SET_MODAL_ID', modalId);

			if (modalId.startsWith('blockModal')) {
				dispatch('getModalLocal', modalId);
			} else {
				await dispatch('loadModalArticle', modalId);
			}
		},
		getModalLocal({ commit, getters, rootState }, modalId) {
			const id = modalId.replace('blockModal-', '');
			const { editorApi } = rootState;
			const articleData = getters.getArticleContentById(getters.currentArticle.id);
			const modalElement = getBlockModal({
				id,
				content: editorApi.active ? editorApi.content : articleData?.content,
			});
			commit('SET_MODAL_CONTENT', modalElement?.elements[1]?.elements);
			commit('SET_MODAL_MODIFIER', modalElement?.modifier);
		},
		async loadModalArticle({ rootState, commit, getters }, modalId) {
			const exhibition = getters.currentExhibition;
			const language = getters.currentLanguage;
			const articleVersion = getArticleVersion({
				state: rootState,
				articleID: modalId,
				exhibitionID: exhibition.exhibitionID,
			});
			const url = new URL(
				`./apps/article-${modalId}-${articleVersion}/${language}.content`,
				rootState.dataSourceURL
			);
			let result;
			try {
				result = await Vue.http.get(url.toString());
			} catch (error) {
				// console.error(error);
			}
			if (Array.isArray(result.body.mediaObjects)) {
				commit('addToMediaObjectMap', {
					mediaObjectArray: setMediaObjectsSources(result.body.mediaObjects, rootState.dataSourceURL),
				});
			}
			commit('SET_MODAL_CONTENT', result.body.content.elements[1].elements);
			commit('SET_MODAL_MODIFIER', result.body.content.modifier);
		},
	},
	getters: {
		getModalContent(state) {
			return state.content;
		},
		getModalModifier(state) {
			return state.modifier;
		},
	},
};
